module.exports = __webpack_public_path__ + "static/img/Book.5d05dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Book.png
// module id = 244
// module chunks = 1